import { parsePhoneNumberFromString, validatePhoneNumberLength, } from 'libphonenumber-js/max';
/**
 * Parses the input phone number and returns its country region.
 * Example:'+4581827914' => 'dk'
 *
 * @param e164_format The phone number.
 */
export function getCountryCodeFromPhoneNumber(e164_format) {
    try {
        const phoneNumber = parsePhoneNumberFromString(e164_format || '');
        if (phoneNumber?.country) {
            return phoneNumber.country.toLowerCase();
        }
    }
    catch (error) {
        return undefined;
    }
}
/**
 * Converts a phone number in string to E164 format
 *
 * @param number Phone number string
 */
export const formatE164 = (number) => {
    try {
        const phoneNumber = parsePhoneNumberFromString(number || '');
        return phoneNumber?.number;
    }
    catch (error) {
        return undefined;
    }
};
/**
 * Converts a phone number in string to International format
 *
 * @param number Phone number string
 */
export const formatInternational = (number) => {
    try {
        const phoneNumber = parsePhoneNumberFromString(number || '');
        return phoneNumber?.format('INTERNATIONAL');
    }
    catch (error) {
        return undefined;
    }
};
/**
 * Parses the input phone number and returns its country code.
 * Example:'+4581827914' => 45
 */
export const getPhoneNumberCountryCodeAsNumber = (number) => {
    try {
        const phoneNumber = parsePhoneNumberFromString(number || '');
        if (phoneNumber?.countryCallingCode) {
            return parseInt(phoneNumber.countryCallingCode, 10);
        }
    }
    catch (error) {
        return undefined;
    }
};
/**
 * Parses the input phone number and returns its country code.
 * Example:'+4581827914' => '+45'
 */
export const getPhoneNumberCountryCodeFormatted = (number) => {
    const countryCode = getPhoneNumberCountryCodeAsNumber(number);
    return countryCode ? `+${countryCode}` : undefined;
};
/**
 * Parses the input phone number and returns nationality (significant) part of
 * the number.
 */
export const getPhoneNumberNationalNumber = (number) => {
    try {
        const phoneNumber = parsePhoneNumberFromString(number || '');
        if (phoneNumber?.nationalNumber) {
            return parseInt(phoneNumber.nationalNumber, 10);
        }
    }
    catch (error) {
        return undefined;
    }
};
/**
 * Checks wheter a number is valid or not. The input number can be in
 * International, National and E.164 formats.
 */
export const isValidPhoneNumber = (number) => {
    try {
        const phoneNumber = parsePhoneNumberFromString(number || '');
        return phoneNumber?.isValid() ?? false;
    }
    catch (error) {
        return false;
    }
};
/**
 * Checks wheter a number is possible or not. The input number can be in
 * International, National and E.164 formats.
 */
export const isPossiblePhoneNumber = (number) => {
    try {
        const phoneNumber = parsePhoneNumberFromString(number || '');
        return phoneNumber?.isPossible() ?? false;
    }
    catch (error) {
        return false;
    }
};
export const validatePossibleNumberWithReason = (number) => {
    if (isPossiblePhoneNumber(number) && isValidPhoneNumber(number)) {
        return ValidationResult.IS_POSSIBLE;
    }
    try {
        switch (validatePhoneNumberLength(number || '')) {
            // Length is fine, the number only fails the region pattern. Mirrors the
            // previous behaviour where the reason only reflected the length check.
            case undefined:
                return ValidationResult.IS_POSSIBLE;
            case 'INVALID_COUNTRY':
            case 'NOT_A_NUMBER':
                return ValidationResult.INVALID_COUNTRY_CODE;
            case 'TOO_SHORT':
                return ValidationResult.TOO_SHORT;
            case 'TOO_LONG':
                return ValidationResult.TOO_LONG;
            default:
                return ValidationResult.UNKNOWN;
        }
    }
    catch (error) {
        return ValidationResult.UNKNOWN;
    }
};
export const ValidationResult = {
    IS_POSSIBLE: 'is-possible',
    INVALID_COUNTRY_CODE: 'invalid-country-code',
    TOO_SHORT: 'too-short',
    TOO_LONG: 'too-long',
    UNKNOWN: 'unknown',
};
//# sourceMappingURL=phone.js.map